
<template>
    <!-- <el-card :style="{height:height,width:width}"> -->
      <el-row>
        <el-col>
          <!-- <div class="title">
            {{ componentData.title }}
          </div> -->
          <v-chart class="vchart" :option="scatterplotOptions" :style="{height:vchartHeight,width:width}"/>
        </el-col>
      </el-row>
    <!-- </el-card> -->
</template>

<script>

import request from '@/utils/request'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { ScatterChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'
import { ref, defineComponent } from 'vue'

use([
  CanvasRenderer,
  ScatterChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
])

export default {
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: 'white'
  },
  props: {
    componentData: {
      type: Object,
      default: {}
    },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '400px'
      },
  },
    computed: {
      // a computed getter
      vchartHeight() {
          // if(this.height != null){
          //     var h = this.height.replace("px", "");
          //     if(this.componentData.title != null){
          //       h = h-64;
          //     }
          //     return (h)+'px'
          // }
          return '550px'
      }
    },
  data() {
    return {
      scatterplotOptions: {}
    }
  },
  watch: {
    componentData(newV) {
      this.init(newV)
    }
  },
  mounted() {
    this.init(this.componentData)
  },
  methods: {
    init(data) {
      const self = this
      if(data.mockData) {
        self.showCharts(data.chartOptions,data.mockData)
      }else {
        request(data.requestOption).then(response => {
          if (response.code == 0) {
            self.showCharts(data.chartOptions,response.data)
          } else {
            //self.$message.error('获取失败');
          }
        }).catch(function (result) {

          //self.$message.error('获取失败');
        })
      }
    },
    showCharts(opt,data) {
      const self = this
      var option = opt;
      if(option.xAxis == undefined){
        option.xAxis = {};
      }
      if(option.xAxis.data == undefined
        && self.componentData.transform.transformx != undefined){
        option.xAxis.data = self.componentData.transform.transformx(data);
      }
      if(option.yAxis == undefined){
        option.yAxis = {};
      }
      if(option.yAxis.data == undefined
        && self.componentData.transform.transformy != undefined){
        option.yAxis.data = self.componentData.transform.transformy(data);
      }
      if(option.series == undefined){
        option.series = {};
      }
      if(option.series.data == undefined
        && self.componentData.transform.transformdata != undefined){
        option.series.data = self.componentData.transform.transformdata(data);
      }
      this.scatterplotOptions = option
    }
  }
}

</script>

<style lang="scss" scoped>

.card-panel{
    padding:10px;
}
.card-panel-text-title{
    color: white;
    font-size: 20px;
    margin-top:10px;
    margin-bottom:10px;
}

.card-panel-text{
    color: white;
    font-size: 20px;
}
      .card-panel-col {
        background: linear-gradient(45deg,  #13ce66, #13ce66);
        margin-bottom: 12px;
        margin-top: 12px;
        margin-left: 12px;
        margin-right: 12px;
        border-radius:5px;
  }
.title {
  border-bottom: 1px solid #ebebeb;
  padding-left:10px;
  padding-bottom:10px;
  padding-top:10px;
  font-size: 18px;
  color:white;
  background-color: #1988EC;
  width:100%;
}

::v-deep .el-progress {
    .el-progress-bar__outer {
      background-color: rgba(255,255,255,.5);
      .el-progress-bar__inner {
        background-color: #ffffff;

      }
    }
    .el-progress__text {
    color: #ffffff;
  }

}

.chart {
  width:560px;
  height: 460px;
  padding-left:20px;
  padding-right:20px;
}
.vchart {
  width:500px;
  height: 500px;
}
</style>
